import React, { useEffect, useState } from 'react';
import './App.scss';
import { Routing } from './Components/Routing';
import { Button } from '@material-ui/core';
import theme from './Components/Helper/theme';
import { ThemeProvider } from '@mui/material/styles';
import { Elements } from '@stripe/react-stripe-js';
import { loadStripe } from '@stripe/stripe-js';
import { CssBaseline } from '@mui/material';
function App() {
  const stripePromise = loadStripe(process.env.REACT_APP_STRIPE_PUBLIC_KEY as string);

  return (
    <Elements stripe={stripePromise}>
      <ThemeProvider theme={theme}>
        <div className="App">
          <Button
            variant="outlined"
            size="small"
            style={{ display: "none" }}
          ></Button>
          <Routing />
        </div >
        <CssBaseline />
      </ThemeProvider>
    </Elements>
  );
}

export default App;
